import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../utils/api';
import { styles, colors } from '../../styles/globalStyles';

export const EmailLogin = ({ onSuccess }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!credentials.email || !credentials.password) {
      setError('Email e senha são obrigatórios');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const api = axios.create({ 
        baseURL: API_URL,
        timeout: 10000
      });
      
      const response = await api.post('/auth/local', {
        email: credentials.email,
        password: credentials.password
      });
      
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.data.token, true);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erro no login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={styles.emailForm}>
      <div style={styles.formGroup}>
        <label style={styles.formLabel}>Email</label>
        <input
          type="email"
          placeholder="seu@email.com"
          value={credentials.email}
          onChange={(e) => setCredentials(prev => ({ ...prev, email: e.target.value }))}
          style={styles.formInput}
          disabled={loading}
          required
        />
      </div>

      <div style={styles.formGroup}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label style={styles.formLabel}>Senha</label>
          <button
            type="button"
            onClick={() => alert('Entre em contato com a administração para redefinir sua senha')}
            style={{
              background: 'none',
              border: 'none',
              color: colors.primary,
              fontSize: '0.75rem',
              cursor: 'pointer',
              padding: 0
            }}
          >
            Esqueceu a senha?
          </button>
        </div>
        <input
          type="password"
          placeholder="Sua senha"
          value={credentials.password}
          onChange={(e) => setCredentials(prev => ({ ...prev, password: e.target.value }))}
          style={styles.formInput}
          disabled={loading}
          required
        />
      </div>

      {error && (
        <div style={{
          backgroundColor: '#fee2e2',
          color: '#991b1b',
          padding: '0.75rem',
          borderRadius: '0.5rem',
          fontSize: '0.875rem',
          marginBottom: '1rem'
        }}>
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        style={{
          ...styles.button,
          ...styles.buttonPrimary,
          width: '100%',
          padding: '0.875rem',
          opacity: loading ? 0.7 : 1,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? (
          <>
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid rgba(255,255,255,0.3)',
              borderTopColor: colors.white,
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            Entrando...
          </>
        ) : (
          'Entrar'
        )}
      </button>
    </form>
  );
};
